import { WizardConfig } from '../type.js';

export const restaurantWizardConfig: WizardConfig = {
  id: 'restaurant',
  name: 'Restaurant Reservation Wizard',
  fieldDefinitions: [
    { name: 'cuisine', required: true, defaultValue: null },
    { name: 'location', required: true, defaultValue: null },
    { name: 'date', required: true, defaultValue: null },
    { name: 'time', required: true, defaultValue: null },
    { name: 'partySize', required: true, defaultValue: null },
    { name: 'dietaryRestrictions', required: false, defaultValue: [] }
  ],
  extractionPrompt: `Extract restaurant reservation information from conversations in JSON format.
  Look for both explicit and implied details about:
  - cuisine: Type of food or restaurant style mentioned
  - location: City, neighborhood, or area
  - date: When they want to dine (convert to YYYY-MM-DD)
  - time: What time they want to dine
  - partySize: Number of people in the reservation
  - dietaryRestrictions: Any food allergies or preferences

  IMPORTANT: For any information that is not provided or unclear, use null in your JSON response.
  ALWAYS return properly formatted JSON with ALL fields, even if values are null.
  
  Output your response in this format:
  1. First a valid JSON object with the extracted fields
  2. Then any explanatory text`,
  completionPrompt: `Create a brief, friendly summary of a restaurant reservation.
  The details are:
  - Cuisine: {{cuisine}}
  - Location: {{location}}
  - Date: {{date}}
  - Time: {{time}}
  - Party Size: {{partySize}}
  - Dietary Restrictions: {{dietaryRestrictions}}
  
  Keep it under 50 words, be conversational, and confirm you'll look for reservation options.`
};